export const FEATURE_NAME = '@zerops/zerops/feature/token-add-edit-dialog';
